export enum StationPressureType {
  LowMediumPressure = 'Low/Medium Pressure',
  HighPressure = 'High Pressure',
  WasteWaterTreatment = 'Wastewater Treatment',
}
